import { render, staticRenderFns } from "./Watcher.vue?vue&type=template&id=ba5cb42e&scoped=true&lang=pug&"
import script from "./Watcher.vue?vue&type=script&lang=ts&"
export * from "./Watcher.vue?vue&type=script&lang=ts&"
import style0 from "./Watcher.vue?vue&type=style&index=0&id=ba5cb42e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5cb42e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
